export default "__VITE_PUBLIC_ASSET__c5dce1fa__"